import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';

const StyledButton = styled.div`
  width: 100%;
  background-color: #f2f2f2;
  color: #999;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  &:hover, &:focus {
    text-decoration: underline
  }
`;

const ButtonLabel = styled.span`
  width: auto;
  max-width: calc(100% - 25px);
  max-height: 28px;
  overflow: hidden;
  font-size: 13px;
  padding-left: 2px;
  vertical-align: middle;
`;

export default function CompareAddItemButton(props) {

  return (
    <StyledButton onClick={props.onAddItem}>
      <Icon icon={props.icon} />
      <ButtonLabel>{props.label}</ButtonLabel>
    </StyledButton>
  );
}

CompareAddItemButton.displayName = 'CompareAddItemButton';

CompareAddItemButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onAddItem: PropTypes.func.isRequired
};

CompareAddItemButton.defaultProps = {
  icon: 'Plus'
};
